import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent } from "@/components/ui/card";

export function EmailStatCard({
  label,
  value,
  loading,
  tone,
}: {
  label: string;
  value: number | null;
  loading: boolean;
  tone?: "success" | "danger" | "warning";
}) {
  const toneClass =
    tone === "success"
      ? "text-emerald-600 dark:text-emerald-400"
      : tone === "danger"
      ? "text-destructive"
      : tone === "warning"
      ? "text-amber-600 dark:text-amber-400"
      : "text-foreground";
  return (
    <Card className="border-muted">
      <CardContent className="p-4">
        <div className="text-xs uppercase tracking-wide text-muted-foreground">{label}</div>
        <div className={`mt-1 text-2xl font-semibold ${toneClass}`}>
          {loading && value === null ? <Skeleton className="h-7 w-16" /> : value ?? 0}
        </div>
      </CardContent>
    </Card>
  );
}
